import { render, staticRenderFns } from "./WidgetUltimasVendasVendedor.vue?vue&type=template&id=00af7e1e&scoped=true"
import script from "./WidgetUltimasVendasVendedor.vue?vue&type=script&lang=ts"
export * from "./WidgetUltimasVendasVendedor.vue?vue&type=script&lang=ts"
import style0 from "./WidgetUltimasVendasVendedor.vue?vue&type=style&index=0&id=00af7e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af7e1e",
  null
  
)

export default component.exports